import { connect } from 'react-redux'
import Select from './Select'

export default connect(
	(state) => ({ value: state.campaign.addOrEdit.newEventGoal?.id || 'blank' }),
	null,
)(Select)
